(() => {
  // Groups: [data-sc-zoom] holds pictures marked [data-sc-full]. Dawn's product gallery is a group too.
  const PRODUCT = 'product-info .product__media-list';
  let box, img, caption, count, prev, next, items = [], index = 0, opener = null;

  const full = (el) => {
    const src = el.dataset.scFull || el.currentSrc || el.src;
    try {
      const url = new URL(src, location.href);
      if (url.hostname.endsWith('shopify.com') || url.pathname.includes('/cdn/shop/')) url.searchParams.set('width', '2000');
      return url.href;
    } catch {
      return src;
    }
  };

  const build = () => {
    box = document.createElement('div');
    box.className = 'sc-lightbox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', window.scStrings.imageGallery);
    box.innerHTML = `
      <figure class="sc-lightbox__figure">
        <img class="sc-lightbox__img" alt="">
        <figcaption class="sc-lightbox__caption"><span class="sc-lightbox__count"></span><span class="sc-lightbox__text"></span></figcaption>
      </figure>
      <button type="button" class="sc-lightbox__btn sc-lightbox__close" aria-label="Close"></button>
      <button type="button" class="sc-lightbox__btn sc-lightbox__nav sc-lightbox__nav--prev" aria-label="Previous image"></button>
      <button type="button" class="sc-lightbox__btn sc-lightbox__nav sc-lightbox__nav--next" aria-label="Next image"></button>`;
    document.body.append(box);
    img = box.querySelector('.sc-lightbox__img');
    caption = box.querySelector('.sc-lightbox__text');
    count = box.querySelector('.sc-lightbox__count');
    prev = box.querySelector('.sc-lightbox__nav--prev');
    next = box.querySelector('.sc-lightbox__nav--next');
    box.querySelector('.sc-lightbox__close').addEventListener('click', close);
    prev.addEventListener('click', () => show(index - 1));
    next.addEventListener('click', () => show(index + 1));
    box.addEventListener('click', (e) => {
      if (e.target === box || e.target.classList.contains('sc-lightbox__figure')) close();
    });
    box.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft' && items.length > 1) show(index - 1);
      if (e.key === 'ArrowRight' && items.length > 1) show(index + 1);
      if (e.key === 'Tab') {
        const f = [...box.querySelectorAll('button:not([hidden])')];
        const i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
      }
    });
  };

  const show = (i) => {
    index = (i + items.length) % items.length;
    const el = items[index];
    img.src = full(el);
    img.alt = el.alt || '';
    caption.textContent = el.alt || '';
    count.textContent = items.length > 1 ? `${index + 1} / ${items.length}` : '';
  };

  const open = (group, clicked, from) => {
    let start = group.indexOf(clicked);
    if (start < 0 && clicked) {
      const twin = clicked.closest('[aria-hidden="true"]');
      if (twin) start = [...twin.querySelectorAll('[data-sc-full]:not([data-sc-full=""])')].indexOf(clicked);
    }
    if (!box) build();
    items = group;
    opener = from;
    prev.hidden = next.hidden = items.length < 2;
    show(Math.max(0, start));
    box.hidden = false;
    document.documentElement.classList.add('sc-lightbox-open');
    requestAnimationFrame(() => box.classList.add('is-open'));
    box.querySelector('.sc-lightbox__close').focus();
  };

  function close() {
    box.classList.remove('is-open');
    box.hidden = true;
    img.removeAttribute('src');
    document.documentElement.classList.remove('sc-lightbox-open');
    opener?.focus();
  }

  document.addEventListener(
    'click',
    (e) => {
      if (window.Shopify?.designMode) return;
      // Dawn's product gallery: take over its own lightbox for photos (videos and 3D keep Dawn's).
      const toggle = e.target.closest(`${PRODUCT} .product__media-toggle`);
      if (toggle) {
        const item = toggle.closest('.product__media-item');
        const picture = item?.querySelector('.product__media img');
        if (!picture || item.classList.contains('product__media-item--video') || item.querySelector('deferred-media')) return;
        e.preventDefault();
        e.stopPropagation();
        const list = toggle.closest('.product__media-list');
        const group = [...list.querySelectorAll('.product__media-item')]
          .filter((m) => !m.querySelector('deferred-media'))
          .map((m) => m.querySelector('.product__media img'))
          .filter(Boolean);
        open(group, picture, toggle);
        return;
      }
      const link = e.target.closest('[data-sc-zoom] a[data-sc-zoom-link]');
      if (!link) return;
      const root = link.closest('[data-sc-zoom]');
      const group = [...root.querySelectorAll('[data-sc-full]:not([data-sc-full=""])')].filter((el) => !el.closest('[aria-hidden="true"]'));
      const clicked = link.querySelector('[data-sc-full].is-active') || link.querySelector('[data-sc-full]:not([data-sc-full=""])');
      if (!group.length) return;
      e.preventDefault();
      e.stopPropagation();
      open(group, clicked, link);
    },
    true
  );
})();
